import { STAYS, matchesStay } from '../lib/stays.js'

/**
 * "How long?" as a row of toggle chips: 30 min · 1 h · 2 h · 3 h · Přes noc.
 * Tapping the active chip clears the stay (back to the free/paid map). Any
 * other stay is the StaySlider's job.
 */
export default function StayChips({ t, lang, durationText, setDurationText }) {
  return (
    <div className="chips chips--scroll" role="group" aria-label={t('stayLabel')}>
      {STAYS.map((s) => {
        const value = s.value(lang)
        const active = matchesStay(durationText || '', value)
        return (
          <button
            key={s.key}
            type="button"
            className={`chip ${active ? 'is-active' : ''}`}
            aria-pressed={active}
            onClick={() => setDurationText(active ? '' : value)}
          >
            {t(s.key)}
          </button>
        )
      })}
    </div>
  )
}
